export enum ViewState {
    loading = 0,
    content = 1,
    error = 2,
    updated = 3,
    initial = 4
}